import { Outlet } from "react-router-dom";

export function WorkshopLayout() {
  return (
    <div className="flex h-screen flex-col">
      <main className="flex flex-1 flex-col overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}
